import _ from 'lodash';

import { Keys } from 'assets/js/api/settings';
import { UserSettingFactoryArray, UserSettingFactoryObject }
  from 'assets/js/usersettings/factories';

export const UserSettings = (store) => ({
  AccountTemplates: new UserSettingFactoryObject(store, Keys.AccountTemplates),
  CollapsedCategories:
    new UserSettingFactoryObject(store, Keys.CollapsedCategories),
  DashboardReservationsFutureDays:
    new UserSettingFactoryObject(store, Keys.DashboardReservationsFutureDays),
  DefaultAdminSite:
    new UserSettingFactoryObject(store, Keys.DefaultAdminSite),
  FilterGlobals: new UserSettingFactoryObject(store, Keys.FilterGlobals),
  HelpBoxes: new UserSettingFactoryObject(store, Keys.HelpBoxes),
  HiddenSites: new UserSettingFactoryArray(store, Keys.HiddenDashboardSites),
  LiveMaps: new UserSettingFactoryObject(store, Keys.LiveMaps),
  OnlyShowRatesRequiringApproval:
    new UserSettingFactoryObject(store, Keys.OnlyShowRatesRequiringApproval),
  Reservations: new UserSettingFactoryObject(store, Keys.Reservations),
  ShowExpandedDashboardReservations:
    new UserSettingFactoryObject(store, Keys.ShowExpandedDashboardReservations),
  ShowOldDashboardApprovals:
    new UserSettingFactoryObject(store, Keys.ShowOldDashboardApprovals),
  ShowApprovedDashboardApprovals:
    new UserSettingFactoryObject(store, Keys.ShowApprovedDashboardApprovals),
  ReleaseNotesHead:
    new UserSettingFactoryObject(store, Keys.ReleaseNotesHead),
  ShowAdvancedInvoiceItems:
    new UserSettingFactoryObject(store, Keys.ShowAdvancedInvoiceItems),
});
